"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorPolicyDetailsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualMotorPolicyDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorPolicyDetailsWidget, _super);
    function AnnualMotorPolicyDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        var paymentOption = _this.props.interaction.factors ? _this.props.interaction.factors.premiumType : undefined;
        _this.state = {
            paymentOption: paymentOption
        };
        return _this;
    }
    AnnualMotorPolicyDetailsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderPolicyDetails()));
    };
    AnnualMotorPolicyDetailsWidget.prototype.getIsOptionalExtraIncludedText = function (coverTier, optionalExtra) {
        if (coverTier === undefined || coverTier === "" || coverTier === services_1.ALLIANZ) {
            return "Included as standard";
        }
        return optionalExtra ? "Included" : "Not included";
    };
    AnnualMotorPolicyDetailsWidget.prototype.renderPolicyDetails = function () {
        var coverLevel = (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier);
        return (React.createElement(React.Fragment, null,
            React.createElement("img", { className: "policy-summary-icon policy-icon grid-row-1-3", src: "/".concat(services_1.resourcesHelper.THEME, "/img/policy-summary.png"), alt: "Policy summary icon" }),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Cover type:"),
                React.createElement("div", { className: "detail-value font-weight-extra-light" }, "Comprehensive")),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Cover level:"),
                React.createElement("div", { className: "detail-value font-weight-extra-light" }, coverLevel)),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Cover start date:"),
                React.createElement("div", { className: "detail-value font-weight-extra-light", id: "vehicle-startDate" }, moment.utc(this.props.interaction.headerInfo.startDate, moment.ISO_8601).format("DD MMM YYYY"))),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Cover expiry date:"),
                React.createElement("div", { className: "detail-value font-weight-extra-light", id: "vehicle0-endDate" },
                    moment.utc(this.props.interaction.headerInfo.endDate, moment.ISO_8601).format("DD MMM YYYY"),
                    ", 23:59")),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Motor legal expenses:"),
                React.createElement("div", { className: "detail-value" }, this.getIsOptionalExtraIncludedText(this.props.interaction.coverTier, this.props.interaction.optionalExtras.motorLegalExpenses))),
            React.createElement("div", { className: "detail pt-4" },
                React.createElement("div", { className: "detail-key" }, "Guaranteed hire car:"),
                React.createElement("div", { className: "detail-value" }, this.getIsOptionalExtraIncludedText(this.props.interaction.coverTier, this.props.interaction.optionalExtras.courtesyCar)))));
    };
    ;
    return AnnualMotorPolicyDetailsWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorPolicyDetailsWidget = AnnualMotorPolicyDetailsWidget;
//# sourceMappingURL=AnnualMotorPolicyDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/AnnualMotorPolicyDetailsWidget.js
// module id = 3193
// module chunks = 0